(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bon-stickers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sticker-animated')) {
    class StickerAnimated extends HTMLElement {
      constructor() {
        super()
        this.spinSpeed = parseFloat(this.dataset.spinSpeed)
        this.floatSpeed = parseFloat(this.dataset.floatSpeed)
        this.spinDirection = parseFloat(this.dataset.spinDirection)

        this.init()

        document.addEventListener('readystatechange', function() {
          if(document.readyState == 'interactive') {
          }
        })
        document.addEventListener("shopify:section:load", (event) => {
          this.init()
        });
      }
      init() {
        this.selecter = ".stckrimg"
        this.stckrimgs = this.querySelectorAll(this.selecter);
        this.scroll();
      }
      scroll() {
        Array.from(this.stckrimgs).forEach(stckrimg => {
          const LT__section = stckrimg.closest(`.luna-templates__animated-sticker`)
          const sticker = this.querySelector('.luna-templates-animated-sticker');

          const update = () => {
            const { bottom } = sticker.getBoundingClientRect();

            const spinEnabled = LT__section.dataset.spinScroll === "true"
            const floatEnabled = LT__section.dataset.floatScroll === "true"

            if (spinEnabled) {
              stckrimg.style.rotate = (bottom * this.spinSpeed * this.spinDirection) + "deg";
            } else {
              stckrimg.style.rotate = 0 + "deg";
            }

            if (floatEnabled) {
              stckrimg.style.top = (((sticker.offsetTop + this.offsetTop) - (window.scrollY + (window.innerHeight / 2))) * this.floatSpeed) + "px";
            } else {
              stckrimg.style.top = "";
            }
          }

          // Set the correct starting value immediately, before any scrolling happens
          update()

          window.addEventListener("scroll", update, {
            passive: true,
            capture: false,
          })
        })
      }
    }
    customElements.define('sticker-animated', StickerAnimated)
  }

  } catch(e) { console.error(e); }
})();
})();
